<p-table [totalRecords]="companyDocuments?.length" #dt [value]="companyDocuments" styleClass="p-datatable-striped" [scrollable]="!isOnMobile && companyDocuments?.length > 5" scrollHeight="500px"
         [globalFilterFields]="['documentType', 'originalFilename']">
  <ng-container *ngIf="showTableCaption">
    <ng-template pTemplate="caption">
      <div class="table-header">
        <div class="view eca-primary-bg" style="min-height: 65px; color: white">
          <div class="as-of-date-container">
            <div class="container-fluid">
              <div class="row">
                <div class="col-3">
                  <div class="as-of-date-container1" style="height: 100%">
                    <h5 class="h5-responsive" style="display: contents">
                      <strong *ngIf="showCount">{{companyDocuments?.length}} {{headerText}}</strong>
                      <strong *ngIf="!showCount">{{headerText}}</strong>
                      <app-eca-ghost-btn (btnClicked)="addDocumentClicked()" *ngIf="showAddDocumentButton" [btnText]="addDocumentButtonText" btnIcon="file-plus" btnType="success"></app-eca-ghost-btn>
                    </h5>
                  </div>
                </div>
                <div class="col">
                  <div class="float-right">
                    <div class="as-of-date-container" style="margin-top: 5px; margin-right: 5px">
                      <span style="font-size: 1.2rem; color: white; margin-right: 5px">Include Expired?</span>
                      <div style="margin-right: 10px">
                        <app-eca-checkbox [label]="'Include Expired?'" [(value)]="expiredFilter.includeExpired"
                                          (valueChange)="expiredFilterChanged()"></app-eca-checkbox>
                      </div>
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                               (input)="dt.filterGlobal($event.target.value, 'contains')"
                               placeholder="Search All" style="height: 90%" />
                      </span>
                      <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"></app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 8rem;" pSortableColumn="documentType">
        Type
        <p-sortIcon field="documentType"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="documentCreationDate?.dateTime">
        Created On
        <p-sortIcon field="documentCreationDate?.dateTime"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="expiryDate?.dateTime">
        Expires On
        <p-sortIcon field="expiryDate?.dateTime"></p-sortIcon>
      </th>
      <th style="width: 10rem;" pSortableColumn="originalFilename">
        Original Filename
        <p-sortIcon field="originalFilename"></p-sortIcon>
      </th>
      <th style="width: 10rem;" pSortableColumn="totalObservations">
        Observations
        <p-sortIcon field="totalObservations"></p-sortIcon>
      </th>
      <th style="font-weight: bold; width: 8rem;"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-companyDocument style="margin: 15px;">
    <tr>
      <td>{{ companyDocument.documentType }}</td>
      <td>{{ companyDocument.documentCreationDate?.dateTime | date: 'dd/MM/yyyy' }}</td>
      <td>{{ companyDocument?.expiryDate?.dateTime | date: 'dd/MM/yyyy' }}</td>
      <td>{{ companyDocument.originalFilename }}</td>
      <td>{{ companyDocument.totalObservations }}</td>
      <td>
        <div class="text-center">
          <app-eca-row-menu (viewBtnClicked)="viewCompanyDocumentClicked(companyDocument)"
                            [rowMenuItems]="rowMenuItems"
                            [contextItem]="companyDocument">
          </app-eca-row-menu>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
